import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebase";

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await signInWithEmailAndPassword(auth, email, pass);
      onLogin(); // Poinformuj App, że jesteś zalogowany
    } catch (err) {
      setError("Błędny e-mail lub hasło!");
    }
  };

  return (
    <form onSubmit={handleLogin} className="max-w-xs mx-auto mt-10 bg-white p-6 rounded-xl shadow">
      <h2 className="text-xl mb-4 font-bold text-blue-700">Logowanie admina</h2>
      <input type="email" className="input mb-2" placeholder="E-mail" value={email} onChange={e => setEmail(e.target.value)} />
      <input type="password" className="input mb-2" placeholder="Hasło" value={pass} onChange={e => setPass(e.target.value)} />
      <button className="btn w-full" type="submit">Zaloguj się</button>
      {error && <div className="text-red-600 mt-2">{error}</div>}
    </form>
  );
}
